export default __webpack_public_path__ + "static/media/2.ef6e9038.jpg";